import PageHeader from "../../components/ui/PageHeader";
import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout";
import AuditLogTable from "./AuditLogTable";
import LogOverview from "./LogOverview";
import LogTable from "./LogTable";
import { orangeButton, outlinedButton } from "./logStyles";

type Section = "log" | "overview" | "audit";

/** Platform log, overview and audit log (replaces the CloudWatch log page) */
export default function Logs() {
  const [t] = useTranslation("global");
  const [section, setSection] = useState<Section>("log");

  const sectionButton = (key: Section, label: string) => (
    <Button
      key={key}
      variant={section === key ? "contained" : "outlined"}
      onClick={() => setSection(key)}
      sx={section === key ? orangeButton : outlinedButton}
    >
      {label}
    </Button>
  );

  return (
    <Layout>
      <PageHeader title={t("logs.title")} description={t("logs.intro")} />
      <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap" }}>
        {sectionButton("log", t("logs.sectionLog"))}
        {sectionButton("overview", t("logs.sectionOverview"))}
        {sectionButton("audit", t("logs.sectionAudit"))}
      </Box>
      {section === "log" && <LogTable />}
      {section === "overview" && <LogOverview />}
      {section === "audit" && <AuditLogTable />}
    </Layout>
  );
}
